import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const getStoriesCommentsState = (state: RootState) => state.storiesComments;

export const selectCommentsForStory = (storyId: string) =>
  createSelector([getStoriesCommentsState], (storiesComments) =>
    storiesComments.comments[storyId]?.data.slice().reverse()
  );

export const selectCommentsForStoryContinuationToken = (storyId: string) =>
  createSelector(
    [getStoriesCommentsState],
    (storiesComments) => storiesComments.comments[storyId]?.xMsContinuationToken
  );

export const selectRepliesToCommentOnStory = (commentId: string) =>
  createSelector([getStoriesCommentsState], (storiesComments) =>
    storiesComments.repliesToComments[commentId]?.data.slice().reverse()
  );

export const selectRepliesToCommentsContinuationToken = (commentId: string) =>
  createSelector(
    [getStoriesCommentsState],
    (storiesComments) =>
      storiesComments.repliesToComments[commentId]?.xMsContinuationToken
  );

export const selectLoadingRepliesToCommentOnStory = (commentId: string) =>
  createSelector(
    [getStoriesCommentsState],
    (storiesComments) => storiesComments.loadingRepliesToComments[commentId]
  );

export const selectLoadingCommentsToStory = (storyId: string) =>
  createSelector(
    [getStoriesCommentsState],
    (storiesComments) => storiesComments.loadingComments[storyId]
  );

export const selectLoadingInsertReplyToComment = (commentId?: string) =>
  createSelector([getStoriesCommentsState], (storiesComments) =>
    commentId ? storiesComments.loadingInsertReplyToComment[commentId] : false
  );

export const selectLoadingInsertCommentToStory = createSelector(
  [getStoriesCommentsState],
  (storiesComments) => storiesComments.loadingInsertComment
);

export const selectSelectedStoryComment = createSelector(
  [getStoriesCommentsState],
  (storiesComments) => storiesComments.selectedComment
);

export const selectSelectedStoryCommentLoading = createSelector(
  [getStoriesCommentsState],
  (storiesComments) => storiesComments.selectedCommentLoading
);

export const selectSelectedStoryCommentError = createSelector(
  [getStoriesCommentsState],
  (storiesComments) => storiesComments.selectedCommentError
);

export const selectLoadingUpdateCommentOnStory = (storyId?: string) =>
  createSelector([getStoriesCommentsState], (storiesComments) =>
    storyId ? storiesComments.loadingUpdateComment[storyId] : false
  );

export const selectEditedCommentOnStory = createSelector(
  [getStoriesCommentsState],
  (storiesComments) => storiesComments.editedCommentOnStory
);
